import { useState } from "react";

import {
  faCalendarCheck,
  faLocationCrosshairs
} from "@fortawesome/free-solid-svg-icons";
import { faSeatAirline } from "@fortawesome/pro-solid-svg-icons";

import useCsvUploader from "./csvUploader";

import { createErrorObj, doesFieldExist } from "../../helpers/components/inputs";

const fieldOptions = [
  { label: "Date", value: "date" },
  { label: "Departure", value: "from" },
  { label: "Arrival", value: "to" },
  { label: "Departure/Arrival", value: "fromTo" },
  { label: "Distance (km)", value: "distanceKm" },
  { label: "Distance (mi)", value: "distanceMile" },
  { label: "Class", value: "class" },
  { label: "Airfare Class Code", value: "airfareCode" }
];

const requiredFields = [
  {
    label: "Date",
    description: "When did you take this flight?",
    icon: faCalendarCheck
  },
  {
    label: "Distance",
    description: "Either To/from airport codes OR a distance",
    icon: faLocationCrosshairs
  },
  {
    label: "Passenger Class",
    description: "Either the passenger class OR the airfare class code",
    icon: faSeatAirline
  }
];

const knownFields = [
  { header: "date", field: "date" },
  { header: "class", field: "class" },
  { header: "kilometers", field: "distanceKm" },
  { header: "km", field: "distanceKm" },
  { header: "distanceKm", field: "distanceKm" },
  { header: "miles", field: "distanceMile" },
  { header: "mi", field: "distanceMile" },
  { header: "distanceMile", field: "distanceMile" },
  { header: "departure", field: "from" },
  { header: "arrival", field: "to" },
  { header: "departure/arrival", field: "fromTo" },
  { header: "airfare class code", field: "airfareCode" }
];

const fieldValidator = (headers) => {
  if (!doesFieldExist(headers, "date")) {
    return createErrorObj('Your CSV must include a "date" field');
  }

  if (
    !(
      (doesFieldExist(headers, "from") && doesFieldExist(headers, "to")) ||
      doesFieldExist(headers, "fromTo") ||
      doesFieldExist(headers, "distanceKm") ||
      doesFieldExist(headers, "distanceMile")
    )
  ) {
    return createErrorObj(
      'Your CSV must include "Departure" and "Arrival" fields or " a Distance" field'
    );
  }

  if (
    !(
      doesFieldExist(headers, "class") || doesFieldExist(headers, "airfareCode")
    )
  ) {
    return createErrorObj(
      'Your CSV must include "Class" or "Airfare Code" fields'
    );
  }
  return { success: true };
};

// All flight-sort calc logic (ticket #430), including the sortFlights
// airport-fallback fix and userId attribution, now lives server-side, routed
// through the same Storage-upload -> task-doc -> draft -> review/confirm ->
// commit pipeline ticket #412 built for utilities_csv/office_csv. See
// functions/utils/smart-upload/draftFlightsCsvChunk.js and
// migratedFlightsCsvTransactions.js for the ported logic. docType stays
// "flights" to match functions/index.js's onNewObjectInBucket dispatch.
const useFlightsCsvUploader = ({ open, setOpen }) => {
  const [fileInfo, setFileInfo] = useState({});
  const [matchedHeaders, setMatchedHeaders] = useState([]);

  const csvUploaderSteps = useCsvUploader({
    knownFields,
    fieldOptions,
    open,
    setOpen,
    fileInfo,
    setFileInfo,
    matchedHeaders,
    setMatchedHeaders,
    fieldValidator,
    docType: "flights",
    firstStepText:
      "Upload a CSV of your transactions and we'll automatically sort out the ones that you can offset.",
    requiredFields
  });

  return csvUploaderSteps;
};
export default useFlightsCsvUploader;
